import Calculator from "./UI/Calculator";

function App() {
  return (
      <Calculator/>
  );
}

export default App;
